/** @format */

import React, { useContext, useState, useMemo, useReducer } from "react";
import { useHistory } from "react-router-dom";
import GaugeChart from "react-gauge-chart";

import {
  Grid,
  Button,
  Card,
  Typography,
  CardContent,
  makeStyles,
  Modal,
  Backdrop,
  Fade,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";

import UserContext from "../../context/Globales/UserContext";
import TblDetalleConyuge from "./TblDetalleConyuge";
import TblDirecciones from "./TblDirecciones";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//import Pdf2 from '../pdf/IC/Pdf2';
import Icpdf2Empresa from "../pdf/IC/Icpdf2Empresa";
import Icpdf2Persona from "../pdf/IC/Icpdf2Persona";
import { globales } from "../../helpers/Confi";
import UserReducer from "../../context/Globales/UserReducer";
import { GET_IC } from "../../context/types";

import IndicadoresEmpresas from "./IndicadoresEmpresas";

import PrintIcon from "@material-ui/icons/Print";

import TblDetalleConsultasRut from "./TblDetalleConsultasRut";
import ReactSpeedometer from "react-d3-speedometer";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "80vh",
  },
  tituloTable: {
    backgroundColor: theme.palette.fondotitulos.main,
    // backgroundImage : `url(${FondoImagenes})`,

    minWidth: 200,
    color: "#171717",
    textAlign: "center",
    padding: "20px",
    fontWeight: "250",
    fontSize: "35px",
  },
  TituloIdentificacion: {
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${
      process.env.PUBLIC_URL + "/static/imagen/fondo.jpg"
    })`,
    minWidth: 200,
    color: "black",
    textAlign: "left",
    padding: "15px",
    fontWeight: "450",
    fontSize: "18px",
    height: "auto",
    alignContent: "center",
  },
  fondoTituloIndicadores: {
    backgroundColor: theme.palette.fondotitulos.main,

    minWidth: 200,
    textAlign: "center",
    padding: "15px",
    fontWeight: "300",
    fontSize: "18px",
    height: "auto",
    alignContent: "center",
  },

  FondoTable: {
    backgroundColor: theme.palette.greyFondo.main,
  },

  imageCliente: {
    borderRadius: "50%",
    width: "100px",
    height: "100px",
  },

  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "50%",
  },
  modalPdf: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  paperPdf: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "80%",
  },

  modaldetalle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    overflow: "scroll",
    height: "100%",
  },
  paperdetalle: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "35%",
    height: "25%",
    overflow: "scroll",
  },
  mousePointer: { cursor: "pointer" },

  colorAlto: {
    backgroundColor: "#EA4228",
  },

  colorMedio: {
    backgroundColor: "#F5CD19",
  },
  colorBajo: {
    backgroundColor: "#5BE12C",
  },

  heading: {
    fontSize: theme.typography.pxToRem(16),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const Identificacion = () => {
  const history = useHistory();
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState("panel1");
  const { datoIC, Datodetalleconyuge, DatodetalleDirecciones } =
    useContext(UserContext);

  const [scoreriesgo, setscoreriesgo] = useState(); // validar resultados cumplimiento/ situacion de riesgo
  const [scorecumplimiento, setscorecumplimiento] = useState();
  const [ScorePDF, setScorePDF] = useState();
  const userContext = useContext(UserContext);
  const [Rut, setRut] = useState(datoIC && datoIC.Identificacion?.Rut);

  const [OpenMoldaDetalleConyuge, setOpenModalDetalleConyuge] =
    React.useState(false);
  const [OpenModalDetalleDirecciones, setOpenMOdalDetalleDirecciones] =
    React.useState(false);
  const [OpenModalpdfImprimir, setOpenModalpdfImprimir] = React.useState(false);
  const scoreDato = JSON.parse(localStorage.getItem("score"));

  //const [OpenLoadingpdf, setOpenLoadingpdf] = React.useState(false)

  const parametros = globales(); //  parametros globales:
  // const MSG = mensajeglobales(); // mensaje globales;

  const [state, dispatch] = useReducer(UserReducer, {}); //

  useMemo(() => {
    const ClasificacionScore = (scor) => {
      let posicion = "";
      switch (scor) {
        case "A":
          posicion = "970";
          break;
        case "B":
          posicion = "790";
          break;
        case "C":
          posicion = "576";
          break;
        case "D":
          posicion = "456";
          break;
        case "E":
          posicion = "242";
          break;
        case "F":
          posicion = "120";
          break;
        case "G":
          posicion = "020";
          break;

        default:
          posicion = "002";
          break;
      }
      return posicion;
    };

    if (datoIC && datoIC.Clasificacion != "-" && scoreDato == null) {
      const asigdatosScore = ClasificacionScore(datoIC && datoIC.Clasificacion);

      //  console.log('asigdatosScore',asigdatosScore );

      let asigdatoScoreGrafico = (asigdatosScore * 100) / 100000;
      let asigdatoScorepdf = asigdatosScore;
      // console.log('asigdatosScore',asigdatoScoreGrafico );
      // console.log('asigdatosScore',asigdatoScorepdf );

      setscoreriesgo(parseFloat(asigdatoScoreGrafico));
      setscorecumplimiento(parseFloat(asigdatoScoreGrafico));
      setScorePDF(asigdatoScorepdf); //ASIGNO EL ESTADO DEL SCORE DATOS PARA PDF
    } else if (scoreDato !== null || scoreDato !== 0) {
      setscoreriesgo((scoreDato * 100) / 100000);
      setscorecumplimiento((scoreDato * 100) / 100000);
      setScorePDF(scoreDato); //ASIGNO EL ESTADO DEL SCORE DATOS PARA PDF
      //datoIC && datoIC.DetalleAntecedentesCrediticios.parseInt().Score = ress;
    } else {
      setscoreriesgo(0);
      setscorecumplimiento(0);
      setScorePDF(0);
    }
  }, [datoIC, scoreDato]);

  const handleChangeAccordeon = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const hanleClickOpenConyuge = () => {
    if (
      Datodetalleconyuge == null ||
      Datodetalleconyuge == "ERROR CONSULTA CONYUGE"
    ) {
      setOpenModalDetalleConyuge(true);
      userContext.getDetalleConyuge(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenModalDetalleConyuge(true);
    }
  };

  const hanleClickOpenConyugeClosed = () => {
    setOpenModalDetalleConyuge(false);
  };

  const hanleClickOpenDirecciones = () => {
    if (
      DatodetalleDirecciones == null ||
      DatodetalleDirecciones == "ERROR CONSULTA DIRECCIONES"
    ) {
      setOpenMOdalDetalleDirecciones(true);
      userContext.getDetalleDirecciones(
        datoIC.Identificacion?.Rut.replace(/[.]/g, ""),
        datoIC.ID
      );
    } else {
      setOpenMOdalDetalleDirecciones(true);
    }
  };

  const hanleClickOpenDireccionesClosed = () => {
    setOpenMOdalDetalleDirecciones(false);
  };

  const handleClickPdf = () => {
    setOpenModalpdfImprimir(true);
  };

  const handlClickClosepdf = () => {
    setOpenModalpdfImprimir(false);
  };

  const NuevaConsulta = () => {
    dispatch({ type: GET_IC, payload: null });
    history.push(parametros.rutaServidor + "informe");
  };

  return (
    <>
      <CssBaseline />

      {/* Modal detalle conyuge*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenMoldaDetalleConyuge}
        onClose={hanleClickOpenConyugeClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={OpenMoldaDetalleConyuge}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={hanleClickOpenConyugeClosed}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblDetalleConyuge />
          </div>
        </Fade>
      </Modal>

      {/* Modal detalle Direcciones*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={OpenModalDetalleDirecciones}
        onClose={hanleClickOpenDireccionesClosed}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 2000,
        }}
      >
        <Fade in={OpenModalDetalleDirecciones}>
          <div className={classes.paper}>
            <Typography
              variant="h5"
              align="right"
              onClick={hanleClickOpenDireccionesClosed}
              className={classes.mousePointer}
            >
              X
            </Typography>

            <TblDirecciones />
          </div>
        </Fade>
      </Modal>
      {/*MODAL PDF INFORME COMER*/}
      <Dialog
        fullWidth="xs"
        maxWidth="xs"
        open={OpenModalpdfImprimir}
        // onClose={handleClickPdf}
        aria-label="customized-dialog-title"
      >
        <DialogTitle>Descargar Informe</DialogTitle>
        <DialogContent dividers>
          {datoIC && datoIC.Identificacion?.IsEmpresa ? (
            <Icpdf2Empresa ScorePDF={ScorePDF} />
          ) : (
            <Icpdf2Persona ScorePDF={ScorePDF} />
          )}
          <br />
          <br />
          <div style={{ alignContent: "center", textAlign: "center" }}>
            <Button variant="contained" color="primary" onClick={NuevaConsulta}>
              Nueva Consulta
            </Button>
            <br />
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handlClickClosepdf} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <br />

      <Grid container justify="space-between" alignItems="baseline" >
        <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
          <div  style={{alignItems: 'center', justifyItem: 'center', textAlign: 'right'}}>
        <Typography variant="body2" color="primary">
            <strong>Folio:&nbsp;No.{datoIC && datoIC.ID}</strong><br />
            Fecha:&nbsp; {datoIC && datoIC.Fecha} -{" "}
            {datoIC && datoIC.Hora}
          </Typography>
          </div>
          <img
            variant="contained"
            src={process.env.PUBLIC_URL + "/static/imagen/logonuevoinforme.png"}
            align="center"
            width="98%"
            alt="logo portal cheque"
            title="logo portal cheque"
          />

          {/* <img variant="contained" src={process.env.PUBLIC_URL + '/static/imagen/Infcomercial.gif'} align="center" width="50%" alt="logo portal cheque informe comercial" title="logo portal cheque informe comercial" />*/}

        </Grid>
      </Grid>

      <div className={classes.tituloTable}>
        <Tooltip title="Nueva Consulta">
          <Button variant="outlined" color="primary" onClick={NuevaConsulta}>
            Nueva Consulta
          </Button>
        </Tooltip>
        &nbsp;
        <Tooltip title="Imprimir Informe">
          <Button variant="contained" color="primary" onClick={handleClickPdf}>
            {" "}
            (<PrintIcon />)
          </Button>
        </Tooltip>
        <br />
        <Typography variant="h5">
          {datoIC && datoIC.Identificacion?.IsEmpresa
            ? datoIC && datoIC.DetalleIdentificacionEmpresa?.Nombre
            : datoIC && datoIC.Identificacion?.Nombre}
        </Typography>
        {/*Empresa*/}
        <div
          className="container"
          hidden={datoIC && datoIC.Identificacion?.IsEmpresa === false}
        >
          <Typography variant="body2">
            <strong>Rut: &nbsp;</strong>
            {datoIC && datoIC.Identificacion?.Rut}
          </Typography>
          <Typography variant="body2">
            <strong>Rubro: &nbsp;</strong>
            {datoIC && datoIC.DetalleIdentificacionEmpresa?.Rubro}
          </Typography>
          <Typography variant="body2">
            <strong>Disolución Vigente:&nbsp;</strong>
            {datoIC &&
              datoIC.Resumenes?.DisolucionVigente?.DisolicionVigente}{" "}
          </Typography>
          <Typography variant="body2">
            <strong>Fecha Disolución:&nbsp;</strong>
            {datoIC && datoIC.Resumenes?.DisolucionVigente?.FechaDisolucion}
          </Typography>
          {/*<Button variant="contained" color="primary" onClick={handleClickPdf} >Imprimir informe</Button> <Button variant="contained" color="primary" onClick={NuevaConsulta}>Nueva Consulta</Button>*/}
        </div>
        {/*Persona*/}
        <div
          className="container"
          hidden={datoIC && datoIC.Identificacion?.IsEmpresa === true}
        >
          <Typography variant="body2">
            <strong>Rut: &nbsp;</strong>
            {datoIC && datoIC.Identificacion?.Rut}{" "}
          </Typography>
          <Typography variant="body2">
            <strong>Fecha Nacimiento: &nbsp;</strong>
            {datoIC && datoIC.DetalleIdentificacion?.FechaNacimiento}
          </Typography>
          <Typography variant="body2">
            <strong>Edad: &nbsp;</strong>
            {datoIC && datoIC.DetalleIdentificacion?.Edad}
          </Typography>
          {datoIC && datoIC.Resumenes?.BloquedoCedula != null ? (
            <Typography variant="body2">
              <strong>Estado Vigencia cédula: &nbsp;</strong>
              {datoIC && datoIC.Resumenes?.BloquedoCedula}
            </Typography>
          ) : (
            "SIN INFORMACIÓN"
          )}
          {datoIC && datoIC.Resumenes?.BloquedoCedula != null ? (
            <Typography variant="body2">
              <strong>Número Serie: &nbsp;</strong>
              {datoIC && datoIC.Resumenes?.NSerie}
            </Typography>
          ) : (
            ""
          )}
          {datoIC && datoIC.Resumenes?.Defuncion != null ? (
            <Typography variant="body2">
              <strong>Defunción: &nbsp;</strong>
              {datoIC && datoIC.Resumenes?.Defuncion}
            </Typography>
          ) : (
            ""
          )}
          {/*<Button variant="contained" color="primary" onClick={handleClickPdf} >Imprimir informe</Button> <Button variant="contained" color="primary" onClick={NuevaConsulta}>Nueva Consulta</Button>*/}
        </div>
        {datoIC && datoIC.DetalleIdentificacionEmpresa != null ? (
          <div
            className="container"
            hidden={
              datoIC &&
              datoIC.DetalleIdentificacionEmpresa?.DatosExtras
                ?.ExisteInformacionExtra == false
            }
          >
            <IndicadoresEmpresas />
          </div>
        ) : (
          ""
        )}
        <hr />
        {/* <GraficoSituaCumplimiento />*/}
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12} sm={12} xl={6} md={12} lg={6}>
            <ReactSpeedometer
              width={210}
              height={200}
              needleHeightRatio={0.6}
              value={ScorePDF}
              customSegmentStops={[0, 250, 750, 1000]}
              segmentColors={["#EA4228", "#F5CD19", "#5BE12C"]}
              currentValueText="Situación de Riesgo"
              customSegmentLabels={[
                {
                  text: "ALTO",
                  position: "INSIDE",
                  color: "#0d0d0d",
                },
                {
                  text: "MEDIO",
                  position: "INSIDE",
                  color: "#0d0d0d",
                },
                {
                  text: "BAJO",
                  position: "INSIDE",
                  color: "#0d0d0d",
                },
              ]}
              ringWidth={30}
              needleTransitionDuration={3333}
              needleTransition="easeElastic"
              needleColor={"#0d0d0d"}
              textColor={"#0d0d0d"}
            />
          </Grid>
          <Grid item xs={12} sm={12} xl={6} md={12} lg={6}>

          <Typography variant="body2" align="center">Cumplimiento</Typography>
              <GaugeChart
                id="gauge-chart2"
                nrOfLevels={20}
                colors={["#EA4228", "#F5CD19", "#5BE12C"]}
                percent={scorecumplimiento}
                textColor={"#0d0d0d"}
                hideText={false}
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              />
             
            
          </Grid>
        

        </Grid>
        {/*
        <img src={process.env.PUBLIC_URL + '/static/imagen/indicadoresRiesgo.png'} width="60%" alt="logo portal cheque indicadores de riesgo" title="logo portal cheque indicadore de riesgo" />*/}
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChangeAccordeon("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography style={{ align: "center" }}>
              <b>Antecedentes</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}
            >
              <Grid
                style={{ width: "100%" }}
                item
                xs={12}
                sm={12}
                xl={12}
                md={12}
                lg={12}
              >
                <Card>
                {/*   <div className={classes.fondoTituloIndicadores}>
                    {" "}
                    <b>Antecedentes</b>
                  </div> */}

                  <CardContent style={{ textAlign: "justify" }}>
                    <Typography variant="body2" color="textPrimary">
                      <strong>Ultima Dirección registrada: &nbsp;</strong>
                      {datoIC && datoIC.Identificacion?.IsEmpresa
                        ? datoIC &&
                          datoIC.DetalleIdentificacionEmpresa?.Direccion
                        : datoIC && datoIC.DetalleIdentificacion?.Direccion}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Teléfono uno:&nbsp;</strong>
                      {datoIC && datoIC.Identificacion?.IsEmpresa
                        ? datoIC &&
                          datoIC.DetalleIdentificacionEmpresa?.CodigoArea +
                            "-" +
                            datoIC &&
                          datoIC.DetalleIdentificacionEmpresa?.Telefono
                        : datoIC &&
                          datoIC.DetalleIdentificacion?.CodigoArea +
                            "-" +
                            datoIC &&
                          datoIC.DetalleIdentificacion?.Telefono}{" "}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Teléfono dos:&nbsp;</strong>
                      {datoIC && datoIC.Identificacion?.IsEmpresa
                        ? datoIC &&
                          datoIC.DetalleIdentificacionEmpresa?.CodigoArea2 +
                            "-" +
                            datoIC &&
                          datoIC.DetalleIdentificacionEmpresa?.Telefono2
                        : datoIC &&
                          datoIC.DetalleIdentificacion?.CodigoArea2 +
                            "-" +
                            datoIC &&
                          datoIC.DetalleIdentificacion?.Telefono2}{" "}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Grupo Socio Económico:&nbsp;</strong>
                      {datoIC && datoIC.DetalleIdentificacion?.GSE
                        ? datoIC && datoIC.DetalleIdentificacion?.GSE
                        : "NO"}
                    </Typography>
                    <hr />
                    {datoIC && datoIC.Identificacion?.IsEmpresa ? (
                      <Typography variant="body2" color="textPrimary">
                        <strong>Otras Direcciones Registradas:&nbsp;</strong>
                        {datoIC &&
                        datoIC.DetalleIdentificacionEmpresa?.IsPoseeDirecciones
                          ? "SI" +
                            "-" +
                            `${
                              datoIC &&
                              datoIC.DetalleIdentificacionEmpresa
                                ?.NumeroDireccionesInformadas
                            }`
                          : "NO"}{" "}
                        {datoIC &&
                        datoIC.DetalleIdentificacionEmpresa
                          ?.IsPoseeDirecciones ? (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={hanleClickOpenDirecciones}
                          >
                            Ver detalle
                          </Button>
                        ) : (
                          ""
                        )}
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="textPrimary">
                        <strong>Otras Direcciones Registradas:&nbsp;</strong>
                        {datoIC &&
                        datoIC.DetalleIdentificacion?.IsPoseeDirecciones
                          ? "SI" +
                            "-" +
                            `${
                              datoIC &&
                              datoIC.DetalleIdentificacion
                                ?.DireccionesInformadas
                            }`
                          : "NO"}{" "}
                        {datoIC &&
                        datoIC.DetalleIdentificacion?.IsPoseeDirecciones ? (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={hanleClickOpenDirecciones}
                          >
                            Ver detalle
                          </Button>
                        ) : (
                          ""
                        )}
                      </Typography>
                    )}{" "}
                    <hr />
                    {datoIC && !datoIC.Identificacion?.IsEmpresa ? (
                      <Typography variant="body2" color="textPrimary">
                        <strong>Cónyuge:&nbsp;</strong>{" "}
                        {datoIC && datoIC.DetalleIdentificacion?.IsPoseeConyuge
                          ? "SI"
                          : "NO"}{" "}
                        {datoIC &&
                        datoIC.DetalleIdentificacion?.IsPoseeConyuge ? (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={hanleClickOpenConyuge}
                          >
                            Ver detalle
                          </Button>
                        ) : (
                          ""
                        )}{" "}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChangeAccordeon("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography style={{ align: "center" }}>
              <b> Antecedentes Laborales </b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}
            >
              <Grid
                style={{ width: "100%" }}
                item
                xs={12}
                sm={12}
                xl={12}
                md={12}
                lg={12}
              >
                <Card>
                  {/* <div className={classes.fondoTituloIndicadores}>
                    <b> Antecedentes Laborales </b>
                  </div> */}
                  <CardContent style={{ textAlign: "justify" }}>
                    <Typography variant="body2" color="textPrimary">
                      <strong>Actividad Profesional: &nbsp;</strong>{" "}
                      {datoIC && datoIC.DetalleAntecedentesLaborales?.length > 0
                        ? datoIC &&
                          datoIC.DetalleAntecedentesLaborales[0]
                            .ActividadProfesional
                        : "NO REGISTRA"}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Razón Social:&nbsp;</strong>
                      {datoIC && datoIC.DetalleAntecedentesLaborales?.length > 0
                        ? datoIC &&
                          datoIC.DetalleAntecedentesLaborales[0]
                            .RazonSocialEmpresa
                        : "NO REGISTRA"}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>RUT Empresa:&nbsp;</strong>
                      {datoIC && datoIC.DetalleAntecedentesLaborales?.length > 0
                        ? datoIC &&
                          datoIC.DetalleAntecedentesLaborales[0].RutEmpresa
                        : "NO REGISTRA"}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Direcciones:&nbsp;</strong>
                      {datoIC && datoIC.DetalleAntecedentesLaborales?.length > 0
                        ? datoIC &&
                          datoIC.DetalleAntecedentesLaborales[0].Direccion
                        : "NO REGISTRA"}
                    </Typography>
                    <hr />
                    <Typography variant="body2" color="textPrimary">
                      <strong>Teléfonos:&nbsp;</strong>{" "}
                      {datoIC && datoIC.DetalleAntecedentesLaborales?.length > 0
                        ? datoIC &&
                          datoIC.DetalleAntecedentesLaborales[0].Telefono
                        : "NO REGISTRA"}
                    </Typography>
                    <hr />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChangeAccordeon("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography style={{ align: "center" }}>
              <b>
                {" "}
                Consultas al Rut (
                {datoIC && datoIC.DetallesConsultasRut?.NumeroConsultas})
                últimos 6 meses{" "}
              </b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              direction="column"
              container
              justify="center"
              //alignItems="flex-start"
              spacing={2}
            >
              <Grid
                style={{ width: "100%" }}
                item
                xs={12}
                sm={12}
                xl={12}
                md={12}
                lg={12}
              >
                <TblDetalleConsultasRut />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>

     {/*  <CardContent></CardContent> */}

      {/* OpenLoadingpdf ? <Loading /> : ''}*/}
    </>
  );
};

export default Identificacion;
